import React, { useState } from "react";
import Footer from "../../components/new-home-component/Footer";
import Navbar from "../../components/new-home-component/Navbar";
import contact from "../../assets/contact.png";

// import Navbar from "../components/Navbar";
// import Footer from "../components/Footer"; 

import "./contact.css";
import Pattern from "../../assets/pattern.png";

import { Fade } from "react-awesome-reveal";

import { useContactUs } from "../../hooks/useContactUs";
import Header from "../../components/Header";
import { useNavigate } from "react-router-dom";

const Contact = () => {
  const [name, setName] = useState("");
  const [message, setMessage] = useState("");
  const [email, setEmail] = useState("");
  const { contactus, isLoading, error } = useContactUs(
    {
      email,
      message,
      name,
    },
    setName,
    setEmail,
    setMessage
  );

  const handleContactUs = (e: any) => {
    e.preventDefault();
    contactus();
  };

  console.log(error);

  const navigate = useNavigate();

  // ${
  //   navOver
  //     ? "bg-gray-400 rounded-md bg-clip-padding backdrop-filter backdrop-blur-sm bg-opacity-10"
  //     : ""
  //     }
  return (
    <>
      <div className="relative overflow-x-hidden min-h-[100vh] bg-[#274B89] sm:pt-[200px] pt-[300px]">
        <div
          className={`
         bg-[#102954]
        fixed top-0 w-[100%] z-[100000000]`}
        >
          <Navbar />
          <div className="p-[5%]">
          <p className="text-center font-[600] sm:text-[30px] text-[40px]">
            <span className="text-[#fff]">Reach our</span> <span className="text-[#ff0000] ">Help Desk</span> <span className="text-[#fff]">for support</span>
          </p>
          <p className="text-center text-[#fff] sm:text-[15px] text-[15px] font-[600]">Questions? Need assistance? Our dedicated support team is here to help you every step of the way:</p>
          </div>
        </div>
            {/* space between header an content section */}
        <div className="sm:h-[150px] h-[100px] w-[100%]"></div>
        {/* Content Section 
        an image on the right
        and a form on the left
        */}
        
        <div className="sm:flex block justify-between items-center sm:mt-[100px] mt-[50px] mb-[100px] mx-[5%] z-[40] relative">
          {/* image */}
          <div className="sm:w-[45%] w-[100%] flex justify-center items-center">
            <img
              src={contact}
              alt="contact us"
              className="sm:w-[70%] w-[50%] sm:mb-0 mb-[50px] rounded-[10px]"
            />
          </div>
          {/* form */}
          <div className="sm:w-[45%] w-[100%] flex justify-center items-center">
            <div className="sm:p-[50px] p-[20px] sm:rounded-[20px] rounded-[10px] sm:w-[100%] w-[100%]">
              
              <form action="" onSubmit={handleContactUs}>
              <Fade delay={500}>
              <h3 className="sm:text-[40px] text-[35px] font-[600] text-[#fff]">
                Get in Touch
              </h3>
              <p className="font-[600] mt-[20px] sm:text-[15px] text-[15px] text-[#fff] mb-[10px]">
                Send us a message by filling the forms below.
              </p>
              </Fade>
                <div className="mb-[20px]">
                  <input
                    type="text"
                    placeholder="Your name"
                    className="sm:bg-[#fff] bg-[#fff] sm:w-[100%] w-[100%] sm:h-[50px] h-[40px] sm:px-[20px] px-[10px] outline-none border border-gray-300 rounded-md"
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                </div>
                <div className="mb-[20px]">
                  <input
                    type="text"
                    placeholder="Your email"
                    className="sm:bg-[#fff] bg-[#fff] sm:w-[100%] w-[100%] sm:h-[50px] h-[40px] sm:px-[20px] px-[10px] outline-none border border-gray-300 rounded-md"
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
                <div className="mb-[20px]">
                  <textarea
                    className="sm:bg-[#fff] bg-[#fff] sm:w-[100%] w-[100%] sm:h-[150px] h-[100px] sm:px-[20px] px-[10px] sm:pt-[10px] pt-[5px] outline-none border border-gray-300 rounded-md"
                    placeholder="Your Message"
                    onChange={(e) => setMessage(e.target.value)}
                    required
                  ></textarea>
                </div>
                <div>
                  <p className="font-[600] text-[#fff] mb-[10px]"> 
                    <span>
                      <input
                      type="checkbox"
                      className="mr-[10px]"
                      required
                      />
                  </span>
                  You agree to our friendly <span><a href="/policy" className="text-underline">privacy policy</a></span>.
                  </p>
                </div>
                <div className="flex justify-end">
                  <button
                    className="w-full sm:px-[30px] px-[20px] sm:py-[10px] py-[8px] bg-[#143772] text-[#fff] rounded-full hover:opacity-90 transition-all duration-200"
                    >
                    {isLoading ? "Sending..." : "Send"}
                  </button>
                </div>
              </form>
            </div>

          </div>
        </div>
        {/* <Footer /> */}
        <div className="max-w-7xl mx-auto px-4 md:px-0">
          <Footer />
        </div>
      </div>
      {/* <Footer /> */}
    </>
  );
};

export default Contact;
